import { usePlaceAnOrder } from "@/common/api/mutation";
import { usePermissions } from "@/common/contexts/Permissions.context";
import { Button } from "antd";
import { useNavigate, useParams } from "react-router";
import { queryClient } from "@/common/utils";
import { toast } from "react-toastify";
import CustomTypography from "@/components/Typography/CustomTypography";

interface CustomerActionsProps {
  noBidReason: string | null;
  status: string;
  quoteId: number;
  quoteType: "Budgetary" | "Firm";
}
export default function CustomerActions({
  status,
  quoteId,
  quoteType,
}: CustomerActionsProps) {
  const { mutate } = usePlaceAnOrder();
  const { company, isHavePermission } = usePermissions();
  const params = useParams();
  const quoteLineId = params?.quoteLineId || 0;
  const navigate = useNavigate();
  const onPlaceAnOrderClick = () => {
    if (!quoteId || quoteLineId === 0) return;
    mutate(
      { quoteId, quoteLineId },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries();
          if (company.companyType === "airx") {
            toast.success("Order placed");
            return navigate("/quotes");
          }
          toast.success("Order placed");
          return navigate("/customer/quotes/me");
        },
      }
    );
  };

  if (status === "Quoted" && quoteType === "Firm") {
    return (
      <>
        {isHavePermission("orders_create") ? (
          <Button
            onClick={onPlaceAnOrderClick}
            type="primary"
            className="h-10 font-inter font-semibold"
          >
            Place Order
          </Button>
        ) : (
          <CustomTypography color={"primary"}>
            Order ready to be placed
          </CustomTypography>
        )}
      </>
    );
  }

  return null;
}
